import "core-js/modules/es.object.define-property.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/nodes/common/VersionButton.tsx";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/forbid-component-props */
import React from 'react';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { VersionInfoTooltip } from "../../../SelectDependencies/ModelsTree/VersionButton/VersionInfoTooltip";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VersionButton = /*#__PURE__*/React.memo(function (_ref) {
  var versionName = _ref.versionName,
      hasActions = _ref.hasActions,
      author = _ref.author,
      uploadDate = _ref.uploadDate,
      onClick = _ref.onClick;
  var classes = useStyles();
  return /*#__PURE__*/_jsx(VersionInfoTooltip, {
    author: author,
    uploadDate: uploadDate,
    versionName: versionName // Кнопка версии только для загруженной модели, поэтому статус всегда константный
    ,
    status: 'ImportCompleted',
    children: /*#__PURE__*/_jsxs(Button, {
      size: "small",
      className: clsx(classes.root, _defineProperty({}, classes.clickable, hasActions)) // eslint-disable-next-line no-undefined
      ,
      onClick: hasActions ? onClick : undefined,
      children: [hasActions && /*#__PURE__*/_jsx("span", {
        className: classes.dotWrap,
        children: /*#__PURE__*/_jsx("span", {
          className: classes.dot
        })
      }), "v", versionName]
    })
  });
});
VersionButton.displayName = 'VersionButton';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minWidth: '31px',
      padding: '1.5px 4px',
      backgroundColor: theme.palette.grey[100],
      color: '#00003D',
      fontSize: '10px',
      textTransform: 'none',
      borderRadius: '4px',
      cursor: 'default',
      position: 'relative',
      '&:hover': {
        backgroundColor: theme.palette.grey[100]
      }
    },
    clickable: {
      cursor: 'pointer'
    },
    dotWrap: {
      position: 'absolute',
      top: '-3px',
      right: '-3px',
      width: '10px',
      height: '10px',
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff'
    },
    dot: {
      width: '6px',
      height: '6px',
      borderRadius: '3px',
      backgroundColor: '#0D9966'
    }
  };
});